<template>
  <div class="filter__item">
    <label class="filter__item__title">
      {{ $t('autocaller_v2.operators.field.wrtc') }}
    </label>
    <div class="filter__item__body">
      <i-select :value="value" :clearable="true" :prefix="icon" @input="input">
        <i-option value="1">
          <icon type="md-checkmark" size="18" /> <span class="color-transparent">1</span>
        </i-option>
        <i-option value="0">
          <icon type="md-close" size="18" /> <span class="color-transparent">0</span>
        </i-option>
      </i-select>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      value: {
        type: [Number, String],
        default: ''
      }
    },
    computed: {
      icon() {
        if(parseInt(this.value) === 1) return 'md-checkmark'
        if(parseInt(this.value) === 0) return 'md-close'
        return ''
      }
    },
    methods: {
      input(val) {
        this.$emit('input', val);
      }
    }
  };
</script>

<style lang="scss" scoped>
  .color-transparent{
    color: transparent;
  }
</style>